import { performQuery, performMutation } from "../../service/graphql";
import * as Query from "../../service/graphql/apiQuery";

export const GetCategories = () => {
  // console.log("GetCatagories");
  return performQuery(Query.getCollections, null)
    .then((response) => {
      // console.log('thecoll',response?.data?.collections?.collectionList);
      return response?.data?.collections?.collectionList || [];
    })
    .catch((err) => {
      console.log(err, "GetCategories error");
    });
};

export const GetProductsByCategory = (payload) => {
  // console.log("GetProductsByCategory", payload);
  return performQuery(Query.getProductOnCollection, payload)
    .then((response) => {
      // console.log(response.data, "GetProductsByCategory.data");
      return response.data?.collection?.products?.edges || [];
    })
    .catch((err) => {
      console.log(err, "GetProductsByCategory error");
    });
};

export const ProductGet = (payload) => {
  // console.log("GetProductsByCategory", payload);
  return performQuery(Query.getProductDetails, payload)
    .then((response) => {
      // console.log(payload, "response.data");
      return response.data;
    })
    .catch((err) => {
      console.log(err, "ProductGet error");
    });
};


export const ProductGetByHandle = (payload) => {
  return performQuery(Query.getProductDetailsWithHandle, payload)
    .then((response) => {
      // console.log(response, "ProductGetByHandle.data");
      return response.data;
    })
    .catch((err) => {
      console.log(err, "ProductGetByHandle error");
    });
};

export const ProductSearch = (payload) => {
  // console.log("ProductSearch", payload);
  return performQuery(Query.searchProducts, payload)
    .then((response) => {
      // console.log(response.data, "ProductSearch.data");
      return response?.data?.products?.edges || [];
    })
    .catch((err) => {
      console.log(err, "ProductSearch error");
    });
};

export const ProductsList = (payload) => {
  // console.log("ProductSearch", payload);
  return performQuery(Query.getProducts, payload)
    .then((response) => {
      // console.log(response.data, "response.data");
      return response?.data?.products?.edges || [];
    })
    .catch((err) => {
      console.log(err, "ProductsList error");
    });
};

export const CreateCart = (payload) => {
  // console.log("CartSSS", payload);
  return performMutation(Query.createCartQuery, { input: payload })
    .then((response) => {
      // console.log(response, "dsdsssssssssssssss");
      return response;
    })
    .catch((err) => {
      console.log(err, "CreateCart error");
    });
};

export const AddToCart = (payload) => {
  // console.log("addCartMutt", payload);
  return performMutation(Query.addItemToCartQuery, payload)
    .then((response) => {
      // console.log(response, "dsdsssssssssssssss");
      return response;
    })
    .catch((err) => {
      console.log(err, "AddToCart error");
    });
};

export const CheckOutUrl = (payload) => {
  // console.log("addCart", payload);
  return performMutation(Query.getCheckoutUrlQuery, payload)
    .then((response) => {
      // console.log(response, "dsdsssssssssssssss");
      return response;
    })
    .catch((err) => {
      console.log(err, "CheckOutUrl error");
    });
};

export const GetCart = (payload) => {
  // console.log("addCart", payload);
  return performQuery(Query.getCartQuery, payload)
    .then((response) => {
      console.log(response, "get cart response");
      return response;
    })
    .catch((err) => {
      console.log(err, "GetCart error");
    });
};

export const RemoveFromcart = (payload) => {
  // console.log("addCart", payload);
  return performMutation(Query.removeItemFromCart, payload)
    .then((response) => {
      console.log(response, "dsdsssssssssssssss");
      return response;
    })
    .catch((err) => {
      console.log(err, "RemoveFromcart error");
    });
};

export const UpdateCartProduct = (payload) => {
  return performMutation(Query.updateCartQuery, payload)
    .then((response) => {
      console.log(response, "dsdsssssssssssssss");
      return response;
    })
    .catch((err) => {
      console.log(payload, "UpdateCartProduct error");
    });
};

// export const UpdateCartProduct = async (payload) => {
//   try {
//     const response = await performMutation(Query.updateCartQuery, payload);
//     console.log(response, "Mutation response");

//     if (response && response.data) {
//       return response;
//     } else {
//       console.error("Unexpected response format:", response);
//       return { data: null, errors: ["Unexpected response format"] };
//     }
//   } catch (err) {
//     console.error("UpdateCartProduct error:", err);
//     return { data: null, errors: [err.message || "Unknown error"] };
//   }
// };


export const MyOrders = (payload) => {
  return performQuery(Query.getOrderListQuery, payload)
    .then((response) => {
      console.log(response, "dsdsssssssssssssss");
      return response;
    })
    .catch((err) => {
      console.log(err, "MyOrders error");
    });
};

// export const GetOrderedList = (payload) => {
//   return performQuery(Query.getOrderListQuery, payload)
//     .then((response) => {
//       console.log(response, "dsdsssssssssssssss");
//       return response;
//     })
//     .catch((err) => {
//       console.log(err, "eeeeeeeerrrrrrrr");
//     });
// };



export const getProductPrice = (payload) => {
  // console.log("GetProductsByCategory", payload);
  return performQuery(Query.getProductPrice, payload)
    .then((response) => {
      // console.log(payload, "getProductPrice.data");
      let data = response.data
      console.log({ data });
      return response.data;
    })
    .catch((err) => {
      console.log(err, "getProductPrice error");
    });
};

export const GetProductsByCategoryByHandle = (payload) => {
  return performQuery(Query.getProductOnCollectionByHandle, payload)
    .then((response) => {
      // console.log(response.data,  "GetProductsByCategoryByHandle");
      return response.data?.collection?.products?.edges || [];
    })
    .catch((err) => {
      console.log(err, "GetProductsByCategoryByHandle-error");
    });
};
